// Validates select dropdowns to provide error if placeholder is selected
const validateSelectDropdown = (placeholder, errorMessage) => value => {
  if (value === placeholder) {
    return errorMessage;
  }

  return true; // Validation passed
};

export default validateSelectDropdown;
